<template>
<div class="invoice-page">
  <div class="invoice">
    <div class="invoice-header">
      <div class="invoice-header-con">
        <div class="invoice-header-title">
          <div class="header-title-con">
            开票金额
            <div class="price-small" style="margin-left: 5px">￥</div>
            <div class="header-price">
              <div class="price-big">{{initAmount(totalAmount).amountInteger}}</div>
              <div class="price-small">{{initAmount(totalAmount).amountDecimal}}</div>
            </div>
          </div>
          <img @click="showInvoiceExplain" class="title-icon" src="https://resource.rcclchina.com.cn/invoice/header-question.png" alt="">
        </div>
        <div class="header-tips">
          <div class="header-tips-item">{{invoiceCompany}}</div>
          <div class="header-tips-item">{{invoiceContent}}</div>
          <div class="header-tips-item">可开票金额为实际支付金额，不包括虚拟资产、礼品卡、会员积分券、红包、优惠券等支付金额</div>
        </div>
      </div>
    </div>
    <div class="invoice-con">
      <div class="invoice-info">
        <div class="invoice-info-con">
          <div class="invoice-info-title">
            01 填写发票信息
          </div>
          <div class="invoice-type">
            <div class="invoice-type-left">
              类型
            </div>
            <div class="invoice-type-right">
              <div>
                <label class="invoice-radio" for="invoice-type">
                  <input type="radio" v-model="invoiceInfoType" value="1" id="invoice-type">增值税普通发票（电子发票）
                </label>
              </div>
              <div class="right-tips">提交开票申请后1-5个工作日内推送至您的邮箱/手机号</div>
            </div>
          </div>
          <div class="invoice-type">
            <div class="invoice-type-left">
              拆分
            </div>
            <div class="invoice-type-right">
              <div class="invoice-num">
                <img @click="reduceSplitCount" :src="`https://resource.rcclchina.com.cn/invoice/${splitGuestCount>1 ? 'reduceActive-icon' : 'reduce-icon' }.png`" alt="">
                {{splitGuestCount}}张
                <img @click="addSplitCount" :src="`https://resource.rcclchina.com.cn/invoice/${splitGuestCount>=guestNumber ? 'addForbid-icon' : 'add-icon'}.png`" alt="">
              </div>
            </div>
          </div>
          <div class="invoice-spilt" v-for="(i,idx) in invoiceInfoList" :key="idx">
            <div class="invoice-type" v-if="invoiceInfoList.length===1">
              <div class="invoice-type-left">
                抬头
              </div>
              <div class="invoice-type-right">
                <div v-if="!i.customerName">
                  <div class="title-select" style="color: #bfbfbf" @click="addInvoiceInfo(idx)">
                    请选择发票抬头
                    <img class="title-select-img" src="https://resource.rcclchina.com.cn/invoice/right-icon.png" alt="">
                    <div  v-if="i.showInvoiceTitleMsg" style="left: 230px" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">请输入发票抬头</div>
                  </div>
                </div>
                <div v-else @click="addInvoiceInfo(idx)">
                  <div class="invoice-company">
                    <div class="invoice-company-title">
                      <div class="title-text">{{i.customerName}}</div>
                      <img v-if="i.businessType===1" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type1.png" alt="">
                      <img v-if="i.businessType===2" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type2.png" alt="">
                      <img v-if="i.businessType===3" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type3.png" alt="">
                    </div>
                    <img class="title-select-img" src="https://resource.rcclchina.com.cn/invoice/right-icon.png" alt="">
                  </div>
                  <div v-if="i. nsrsbh" class="right-tips" style="padding: 0">税号:{{ i. nsrsbh}}</div>
                </div>
              </div>
            </div>
            <div class="invoice-type" v-else>
              <div class="invoice-type-left">
                发票{{idx+1}}
              </div>
              <div class="invoice-type-right">
                <div v-if="!i.customerName">
                  <div class="title-select" style="color: #bfbfbf" @click="addInvoiceInfo(idx)">
                    请选择发票抬头
                    <div v-if="i.showInvoiceTitleMsg" style="left: 230px" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">请输入发票抬头</div>
                    <img class="title-select-img" src="https://resource.rcclchina.com.cn/invoice/right-icon.png" alt="">
                  </div>
                </div>
                <div v-else @click="addInvoiceInfo(idx)">
                  <div class="invoice-company">
                    <div class="invoice-company-title">
                      <div class="title-text">{{i.customerName}}</div>
                      <img v-if="i.businessType===1" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type1.png" alt="">
                      <img v-if="i.businessType===2" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type2.png" alt="">
                      <img v-if="i.businessType===3" class="invoice-mark" src="https://resource.rcclchina.com.cn/invoice/invoice-type3.png" alt="">
                    </div>
                    <img class="title-select-img" src="https://resource.rcclchina.com.cn/invoice/right-icon.png" alt="">
                  </div>
                  <div v-if="i. nsrsbh" class="right-tips" style="padding: 0">税号:{{ i. nsrsbh}}</div>
                </div>
                <div class="invoice-item-price">
                  金额
                  <div>
                    ￥<input type="number"
                            placeholder="请输入开票金额"
                            @input="inputAmount(idx)"
                            @blur="inputBlur(idx)"
                            v-model="i.amount"
                            step="0.01">
                  </div>
                  <div v-if="i.showInvoiceMsg" class="noFilled" style="left: 230px"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">{{ i.invoiceMsg }}</div>
                  <div v-if="i.showInvoiceAmountMsg" class="noFilled" style="left: 230px"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">请输入开票金额</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="invoice-receive">
        <div class="invoice-receive-con">
          <div class="invoice-receive-title">
            02 填写接收信息
          </div>
          <div class="invoice-receive-type" @click="showReceiveInfo" v-if="!receiveInfo">
            <img class="type-select-img" src="https://resource.rcclchina.com.cn/invoice/add-icon.png" alt="">
            <div class="title-select" style="color: #bfbfbf">
              <div class="info-tips">
                <div>添加接收信息</div>
                <div v-if="isShowReceiveInfoMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">请输入接收信息</div>
              </div>
              <img class="title-select-img" src="https://resource.rcclchina.com.cn/invoice/right-icon.png" alt="">
            </div>
          </div>
          <div class="invoice-receive-type" @click="showReceiveInfo" v-else>
            <img class="type-select-img" @click.stop="delReceiveInfo" src="https://resource.rcclchina.com.cn/invoice/reduce-icon.png" alt="">
            <div class="title-select" style="color: #bfbfbf">
              <div class="info-tips" style="color: #202020">
                <div>{{receiveType===1 ? '邮箱：':'手机：'}}{{ receiveInfo }}</div>
              </div>
              <img class="title-select-img" src="https://resource.rcclchina.com.cn/invoice/right-icon.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="relation-service" @click="showOnlineService">
        <img src="https://resource.rcclchina.com.cn/invoice/kefu.png" alt="">如有疑问请联系在线客服
      </div>
      <div class="submit-invoice" @click="submitInvoice">
        提交
      </div>
    </div>
  </div>
  <div class="split-tips" v-if="isSplitUpper">本单最多可拆分{{guestNumber}}张</div>
  <InvoicePopup
      v-if="isShowAddInvoice"
      :popup-title="isEditInvoice?'编辑报销凭证抬头':'新增报销凭证抬头'"
      @closePopup="changeAddInvoice">
    <div class="addInvoice-form">
      <div class="addInvoice-item">
        <div class="addInvoice-item-title">类型<img @click="showTypeExplain"  src="https://resource.rcclchina.com.cn/invoice/question-icon.png" alt=""></div>
        <div class="addInvoice-item-content">
          <div class="">
            <label class="invoice-radio" for="addInvoice-enterprise">
              <input type="radio" v-model="currentInvoice.businessType" :value="2" id="addInvoice-enterprise">企业
            </label>
          </div>
          <div>
            <label class="invoice-radio" for="addInvoice-noEnterprise">
              <input type="radio" v-model="currentInvoice.businessType" :value="3" id="addInvoice-noEnterprise">非企业性单位
            </label>
          </div>
          <div>
            <label class="invoice-radio" for="addInvoice-person">
              <input type="radio" v-model="currentInvoice.businessType" :value="1" id="addInvoice-person">个人
            </label>
          </div>
        </div>
        <div class="invoiceTypePopup" v-if="isShowInvoiceType"  :style="currentInvoice.businessType===1 ? 'left: 60px;top:-20px':''">
          <div class="nsrsbh-con">
            <div class="nsrsbh-type">企业</div>
            <div class="nsrsbh-con-item">
              <span class="tips-dot"></span>在境内注册的企业，必须填写税号。
            </div>
            <div class="nsrsbh-con-item">
              <span class="tips-dot"></span>若为境外注册企业，无税号，请在“个人”中填写。
            </div>
            <div class="nsrsbh-type" style="margin-top: 35px">非企业性单位</div>
            <div class="nsrsbh-con-item">
              <span class="tips-dot"></span>如有税号，请必须填写。
            </div>
          </div>
        </div>
      </div>
      <div class="addInvoice-item">
        <div class="addInvoice-item-title">抬头</div>
        <div class="addInvoice-item-content">
          <input type="text" :placeholder="invoiceTypeInfo.title"
                 v-model="currentInvoice.customerName"
                 @input="inputCustomerName"
                 @compositionstart="businessListCompositionStart"
                 @compositionend="businessListCompositionEnd" maxlength="50">
          <div class="companySelect" v-if="showBusinessList">
            <div v-for="(x,idx) in businessList" :key="idx" class="companySelect-item" @click="selectBusiness(x)">
              <div class="companySelect-item-title" >{{ x.titleHtml }}</div>
              <div class="companySelect-item-nsrsbh">{{x.nsrsbh}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="addInvoice-item" v-if="currentInvoice.businessType !==1">
        <div class="addInvoice-item-title">
          税号
          <img @click="showNsrsbhExplain" src="https://resource.rcclchina.com.cn/invoice/question-icon.png" alt="">
        </div>
        <div class="addInvoice-item-content">
          <input type="text" maxlength="20" :placeholder="invoiceTypeInfo.nsrsbh" v-model="currentInvoice.nsrsbh">
        </div>
        <div class="invoiceTypePopup" v-if="isShowNsrsbn" :style="currentInvoice.businessType===1 ? 'left: 60px;top: 0':''">
          <div class="nsrsbh-con" v-if="currentInvoice.businessType!==1">
            <div class="nsrsbh-con-item" style="margin-bottom: 20px;"><span class="tips-dot"></span>纳税人识别号是税务登记证上唯一识别企业的税号，由15-20位字符组成。</div>
            <div class="nsrsbh-con-item"><span class="tips-dot"></span>按照国税总局公告，自2017年7月1日起，企业索取的增值税普通发票需填写纳税人识别号，不符合规定的发票， 不得作为合法税收凭证。</div>
          </div>
          <div class="nsrsbh-con" v-else >
            <div class="nsrsbh-con-item">
              <span class="tips-dot"></span>
              按照国家税务总局政策规定，如需将发票归集至个人所得税APP个人票夹中展示，请提供姓名及身份证号（仅限大陆身份证）；如无需归集，可仅提供姓名。
            </div>
          </div>
        </div>
      </div>
      <div v-if="currentInvoice.businessType!==1">
        <div class="addInvoice-item">
          <div class="addInvoice-item-title">公司地址</div>
          <div class="addInvoice-item-content">
            <input type="text" maxlength="100" placeholder="选填，若有则必须填写" v-model="currentInvoice.customerAddress">
          </div>
        </div>
        <div class="addInvoice-item">
          <div class="addInvoice-item-title">公司电话</div>
          <div class="addInvoice-item-content">
            <input type="text" maxlength="50" placeholder="选填，若有则必须填写" v-model="currentInvoice.customerPhone">
          </div>
        </div>
        <div class="addInvoice-item">
          <div class="addInvoice-item-title">银行名称</div>
          <div class="addInvoice-item-content">
            <input type="text" maxlength="100"  placeholder="选填，若有则必须填写" v-model="currentInvoice.customerBankName">
          </div>
        </div>
        <div class="addInvoice-item">
          <div class="addInvoice-item-title">银行账号</div>
          <div class="addInvoice-item-content">
            <input type="text" maxlength="50"  placeholder="选填，若有则必须填写" v-model="currentInvoice.customerBankCard">
          </div>
        </div>
      </div>
      <div class="form-tips">
        *以上信息仅用于开具发票
      </div>
      <div class="addInvoiceBtn" @click="saveInvoice">提交</div>
      <div v-if="isShowInvoiceTips" class="invoice-info-tips">
        <div>{{ invoiceErrorMsg }}</div>
      </div>
    </div>
  </InvoicePopup>
  <InvoicePopup popupTitle="填写接收信息"
                v-if="isShowReceiveInfo"
                @closePopup="isShowReceiveInfo=false">
    <div class="addInvoice-form">
      <div class="addInvoice-item">
        <div class="addInvoice-item-title">选择方式</div>
        <div class="addInvoice-item-content">
          <div class="">
            <label class="invoice-radio" for="addInvoice-enterprise">
              <input type="radio" v-model="receiveType" :value="1" id="addInvoice-enterprise">邮箱
            </label>
          </div>
          <div>
            <label class="invoice-radio" for="addInvoice-noEnterprise">
              <input type="radio" v-model="receiveType" :value="2" id="addInvoice-noEnterprise">手机号
            </label>
          </div>
        </div>
      </div>
      <div class="addInvoice-item" v-if="receiveType===1">
        <div class="addInvoice-item-title">邮箱地址</div>
        <div class="addInvoice-item-content">
          <input type="text" v-model="receiveInfoValue" placeholder="邮箱地址为必填">
        </div>
      </div>
      <div class="addInvoice-item"  v-if="receiveType===2">
        <div class="addInvoice-item-title">手机号</div>
        <div class="addInvoice-item-content">
          <input type="text" v-model="receiveInfoValue" placeholder="手机号为必填">
        </div>
      </div>
      <div class="receiveInfo-tips">
        <div v-if="verifyReceiveFormMsg" class="noFilled"><img src="https://resource.rcclchina.com.cn/invoice/notFilled-icon.png" alt="">{{verifyReceiveFormMsg}}</div>
      </div>
      <div class="addInvoiceBtn" @click="saveReceiveInfo">提交</div>
    </div>
  </InvoicePopup>
  <InvoicePopup
                v-if="isShowInvoiceExplain"
                popup-title="直客发票开具说明"
                @closePopup="isShowInvoiceExplain=false">
    <div class="addInvoice-form invoice-explain">
      <img src="https://resource.rcclchina.com.cn/invoice/invoice-explain.png" alt="">
    </div>
  </InvoicePopup>
</div>
</template>
<script>
import api from "@/api";
import InvoicePopup from "@/components/Alert/InvoicePopup.vue";
import {checkStr} from "@/utilities/tools";
import {jumpOnlineService} from "@/utilities/common";

export default {
  components: {InvoicePopup},
  data () {
    return {
      invoiceInfoType:1,  //开票类型 目前默认1
      totalAmount:0,  //金额
      splitGuestCount:1,  // 拆分数量
      guestNumber:2,  // 乘客人数
      invoiceCompany:'开票方为皇家加勒比游轮船务（中国）有限公司',
      invoiceContent:'旅游服务*代订住宿费',
      isSplitUpper:false,
      invoiceInfoList:[
        {
          businessType: 2,
          customerName: "",
          amount: null,
          nsrsbh: "",
          customerAddress: "",
          customerPhone: "",
          customerBankName: "",
          customerBankCard: "",
          verifyInfoMsg: "",
          showInvoiceAmountMsg: false,
          showInvoiceTitleMsg:false
        }
      ],
      isShowAddInvoice:false,
      currentInvoice:null, // 发票信息
      isShowInvoiceTips:false,  // 显示发票未填写时提示
      invoiceErrorMsg:'请完整填写报销凭证抬头信息',  // 错误提示
      isShowReceiveInfo:false,  //显示接收信息
      receiveType:1, //接收信息类型 1邮箱 2手机
      receiveInfo:'',  // 接收信息内容
      isShowReceiveInfoMsg:false,
      businessList:null,  // 公司列表
      allowBusinessSearch:true,
      showBusinessList:false,
      bookingRecordIds:'',
      isShowNsrsbn:false,
      isShowInvoiceType:false,
      invoiceTypeInfo:{},  // 弹窗文案
      invoiceApplyId:'',  // 开票后才会有值
      invoiceType:1,
      receiveInfoValue:'',
      verifyReceiveFormMsg:'',
      isShowInvoiceExplain:false, // 开票说明
      ApplyBookingRecordIds:'',
      isEditInvoice:false,
    }
  },
  mounted(){
    this.initPage()
  },
  methods: {
    initPage(){
      let query = this.$route.query
      if(query.bookingRecordIds){
        this.bookingRecordIds = query.bookingRecordIds
      }
      // 是否重新开票
      if(query.invoiceApplyId && query.invoiceApplyId!==''){
        this.invoiceApplyId = query.invoiceApplyId
        this.invoiceType = 2
        // this.getInvoiceInfo()
      }else{
        this.invoiceType = 1
        this.invoiceApplyId = ''
      }
      this.getBookingAmount()
    },
    reduceSplitCount(){
      if(this.splitGuestCount>1){
        this.splitGuestCount--
        if(this.invoiceInfoList.length>0){
          this.invoiceInfoList.splice(this.invoiceInfoList.length-1, 1)
        }
        if(this.invoiceInfoList.length===1){
          this.invoiceInfoList[0].amount = null
        }
      }
    },
    addSplitCount(){
      if(this.isSplitUpper) return
      if(this.splitGuestCount < this.guestNumber){
        this.invoiceInfoList.push({
          businessType: 2,
          customerName: "",
          amount: null,
          nsrsbh: "",
          customerAddress: "",
          customerPhone: "",
          customerBankName: "",
          customerBankCard: "",
          remark: "",
          verifyInfoMsg: "",
          showInvoiceAmountMsg: false,
        })
        this.splitGuestCount++
      }else{
        this.isSplitUpper = true
        setTimeout(()=>{
          this.isSplitUpper = false
        },1500)
      }
    },
    // 添加发票信息
    addInvoiceInfo(idx){
      this.isShowAddInvoice = true
      this.currentInvoice = { ...this.invoiceInfoList[idx], index: idx }
    },
    // 发票金额
    inputAmount(index){
      let amountSum = 0;
      let lastIndex = this.invoiceInfoList.length - 1;
      if(index < lastIndex) {
        let invoiceInfoList = this.invoiceInfoList;
        let amountSumLast = 0;
        let sumCount = 0;
        invoiceInfoList && invoiceInfoList.forEach((invoice,idx)=> {
          if(idx < lastIndex && invoice.amount) {
            amountSumLast += parseFloat(invoice.amount);
            sumCount++;
          }
        });
        let amountLast = 0;
        if(amountSumLast < this.totalAmount) {
          amountLast = (this.totalAmount - amountSumLast).toString();
        }
        if(sumCount < (this.invoiceInfoList.length - 1)) {
          amountLast = null;
        }
        if(amountLast && amountLast.indexOf('.') === -1) {
          amountLast = amountLast + '.00'
        }
        this.invoiceInfoList[lastIndex].amount = amountLast
      }
      this.invoiceInfoList && this.invoiceInfoList.forEach((invoice)=> {
        if(invoice.amount) {
          amountSum += parseFloat(invoice.amount);
        }
      });
      this.invoiceInfoList && this.invoiceInfoList.forEach((invoice)=> {
        invoice.showInvoiceMsg = false;
      })
      if(amountSum < this.totalAmount) {
        this.invoiceInfoList[index].showInvoiceAmountMsg = false
        this.invoiceInfoList[index].showInvoiceMsg = true;
        this.invoiceInfoList[index].invoiceMsg = "拆分金额总和不足可开票金额总和";
      } else if(amountSum > this.totalAmount) {
        this.invoiceInfoList[index].showInvoiceMsg = true;
        this.invoiceInfoList[index].showInvoiceAmountMsg = false
        this.invoiceInfoList[index].invoiceMsg = "拆分金额超限额，请重新输入";
      }
    },
    // 金额输入框失焦
    inputBlur(index){
      let amount = String(this.invoiceInfoList[index].amount);
      if(amount && amount.indexOf('.') === -1) {
        amount = amount + '.00'
      }
      this.invoiceInfoList[index].amount = amount;
    },
    // 保存发票信息
    saveInvoice(){
      let index = this.currentInvoice.index;
      let currentInvoice = this.currentInvoice;
      if(this.isShowInvoiceTips) return;
      if(currentInvoice.customerName === '') {
        this.invoiceErrorMsg = `请完整填写报销凭证抬头信息`;
        this.isShowInvoiceTips = true
        setTimeout(()=>{
          this.isShowInvoiceTips = false
        },1500)
        return
      }
      if(currentInvoice.businessType === 2) {
        if(currentInvoice.nsrsbh === ''){
          this.invoiceErrorMsg = `请完整填写报销凭证抬头信息`;
          this.isShowInvoiceTips = true
          setTimeout(()=>{
            this.isShowInvoiceTips = false
          },1500)
          return;
        }else{
          if(!/^[0-9a-zA-Z]{15,20}$/.test(currentInvoice.nsrsbh)){
            this.invoiceErrorMsg = `请填写正确的税号`;
            this.isShowInvoiceTips = true
            setTimeout(()=>{
              this.isShowInvoiceTips = false
            },1500)
            return;
          }
        }
      }else{
        if(currentInvoice.nsrsbh !== '' && !/^[0-9a-zA-Z]{15,20}$/.test(currentInvoice.nsrsbh)){
          this.invoiceErrorMsg = `请填写正确的税号`;
          this.isShowInvoiceTips = true
          setTimeout(()=>{
            this.isShowInvoiceTips = false
          },1500)
          return
        }
      }
      if(currentInvoice.customerPhone !== '' && !checkStr(currentInvoice.customerPhone.trim(),'telephone')) {
        this.invoiceErrorMsg = `请填写正确的公司电话`;
        this.isShowInvoiceTips = true
        setTimeout(()=>{
          this.isShowInvoiceTips = false
        },1500)
        return;
      }
      let invoiceInfo = {
        ...this.invoiceInfoList[index],
        businessType: currentInvoice.businessType,
        customerName: currentInvoice.customerName.trim(),
        nsrsbh: currentInvoice.nsrsbh.trim(),
        customerAddress: currentInvoice.customerAddress.trim(),
        customerPhone: currentInvoice.customerPhone.trim(),
        customerBankName: currentInvoice.customerBankName.trim(),
        customerBankCard: currentInvoice.customerBankCard.trim(),
        verifyInfoMsg: currentInvoice.customerName ? '' : this.invoiceInfoList[index].verifyInfoMsg
      }
      this.$set(this.invoiceInfoList, index, { ...invoiceInfo });
      this.isShowAddInvoice = false
      this.isEditInvoice = true
      console.log('invoiceInfoList',this.invoiceInfoList)
    },
    showReceiveInfo(){
      this.isShowReceiveInfo = true
    },
    delReceiveInfo(){
      this.receiveInfo = ''
      this.receiveInfoValue = ''
    },
    // 保存接收信息
    saveReceiveInfo(){
      // 验证邮箱
      this.verifyReceiveFormMsg = ''
      if(this.receiveType===1){
        let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        if(this.receiveInfoValue.trim()===''){
          this.verifyReceiveFormMsg = '请填写邮箱地址'
        }else{
          if(!reg.test(this.receiveInfoValue)){
            this.verifyReceiveFormMsg = '请填写正确的邮箱地址'
          }
        }
      }else{  // 验证手机号
        let reg = /^1[3456789]\d{9}$/
        if(this.receiveInfoValue.trim()===''){
          this.verifyReceiveFormMsg = '请填写手机号'
        }else{
          if(!reg.test(this.receiveInfoValue)){
            this.verifyReceiveFormMsg = '请填写正确的手机号'
          }
        }
      }
      if(this.verifyReceiveFormMsg!=='') return
      this.receiveInfo = this.receiveInfoValue
      this.isShowReceiveInfo = false
    },
    // 输入抬头显示公司选择
    async inputCustomerName(event) {
      if(!this.allowBusinessSearch || this.currentInvoice.businessType===1) return;
      // 清除之前的定时器
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      // 设置新的定时器
      this.debounceTimeout = setTimeout(() => {
        this.searchBusinessList(event);
      }, 300); // 300 毫秒后执行
    },
    async searchBusinessList(e) {
      // 获取用户输入并去除前后空白字符
      const keyword = e.target.value.trim();
      this.currentInvoice.customerName = keyword;
      // 如果去除空白后的输入为空，则不显示下拉列表且清空之前的查询结果
      if (!keyword) {
        this.businessList = [];
        this.showBusinessList = false;
      } else {
        let { data,success,errMsg } = await api.booking.getCompanyList({key: this.currentInvoice.customerName})
        if(success){
          this.businessList = this.formatBusinessRows(data, keyword);
          this.showBusinessList = true;
        }else{
          this.$alert.show(errMsg);
        }
      }
    },
    formatBusinessRows(rows, keyword) {
      let currList = [];
      rows && rows.forEach(item => {
        if(item.qymc.indexOf(keyword)>=0) {
          currList.push({
            ...item,
            titleHtml: item.qymc
          })
        }
      });
      return currList;
    },
    businessListCompositionStart() {
      this.allowBusinessSearch = false;
    },
    businessListCompositionEnd(e) {
      this.allowBusinessSearch = true;
      this.inputCustomerName(e);
    },
    // 点击公司，将公司信息填充到输入框中
    selectBusiness(x){
      let companyInfo = {
        ...this.currentInvoice,
        customerName: x.qymc,
        nsrsbh: x.nsrsbh,
        customerAddress: x.dz,
        customerPhone: x.dh,
        customerBankName: x.yh,
        customerBankCard: x.zh,
      }
      this.currentInvoice = { ...companyInfo };
      console.log('currentInvoice',this.currentInvoice)
      this.showBusinessList = false;
    },
    // 获取订单价格和乘客人数
    async getBookingAmount() {
      this.$loading.show();
      // 改为encBookingRecordIds
      let {success, data, errMsg} = await api.booking.getBookingAmount({encBookingRecordIds: this.bookingRecordIds})
      this.$loading.hide();
      if(success){
        this.totalAmount = data.invoiceAmount
        this.guestNumber = data.guestNumber
        this.invoiceCompany = data.invoiceCompany
        this.invoiceContent = data.invoiceContent
        this.ApplyBookingRecordIds = data.invoiceApplyBookingRecordIds
      }else{
        this.$alert.show(errMsg);
      }
    },
    // 联系在线客服
    showOnlineService() {
      jumpOnlineService();
    },
    showTypeExplain(){
      this.isShowInvoiceType = !this.isShowInvoiceType
      this.isShowNsrsbn = false
    },
    showNsrsbhExplain(){
      this.isShowInvoiceType = false
      this.isShowNsrsbn = !this.isShowNsrsbn
    },
    // 点击提交时更改价格属性移除小数点后为00的
    setAmount(e){
      if(e && e.toString().indexOf('.00')>=0){
        return Number(e.toString().replace('.00',''))
      }
      return e
    },
    async getInvoiceInfo() {
      let params = {
        invoiceApplyId: this.invoiceApplyId,
        userName:this.$store.state.user.userToken
      }
      this.$loading.show()
      let {success, data, errMsg} = await api.booking.getBookingRecordInvoice(params)
      this.$loading.hide()
      if(success){
        this.invoiceInfoList = []
        this.totalAmount = 0
        let invoiceList = data.invoiceApplyOrderList
        invoiceList.forEach((i)=>{
          if(i.amount%1===0){
            i.amount = i.amount+'.00'
          }
          this.invoiceInfoList.push({
            businessType: i.businessType,
            customerName: i.gmfMc,
            amount: i.amount,
            nsrsbh: i.gmfNsrsbh,
            customerAddress: i.gmfDz,
            customerPhone: i.gmfDh,
            customerBankName: i.gmfYh,
            customerBankCard: i.gmfZh,
          })
          this.totalAmount += Number(i.amount)
        })
        this.splitGuestCount = invoiceList.length
        this.receiveInfoValue = invoiceList[0].gmfMobile || invoiceList[0].gmfEmail
        this.receiveInfo = invoiceList[0].gmfMobile || invoiceList[0].gmfEmail
        this.receiveType = invoiceList[0].gmfMobile ? 2 : 1
      }else{
        this.$alert.show(errMsg);
      }
    },
    //开发票
    async submitInvoice() {
      let isOkNum = 0;
      let amountSum = 0;
      let invoiceList = [];

      if (this.invoiceInfoList.length === 1) {
        this.invoiceInfoList[0].amount = this.totalAmount;
        if(!this.invoiceInfoList[0].customerName || this.invoiceInfoList[0].customerName === ''){
          this.invoiceInfoList[0].showInvoiceTitleMsg = true;
          isOkNum++;
        }
        if(!this.invoiceInfoList[0].amount || this.invoiceInfoList[0].amount == 0){
          this.invoiceInfoList[0].showInvoiceAmountMsg = true;
          this.invoiceInfoList[0].showInvoiceMsg = false;
          isOkNum++;
        }
        if (!this.receiveInfo || this.receiveInfo === '') {
          this.isShowReceiveInfoMsg = true;
          isOkNum++;
        }
        amountSum = this.setAmount(this.invoiceInfoList[0].amount);
        this.invoiceInfoList.forEach((invoice) => {
          invoiceList.push({
            businessType: invoice.businessType,
            customerName: invoice.customerName,
            amount: this.setAmount(invoice.amount),
            nsrsbh: invoice.nsrsbh,
            customerAddress: invoice.customerAddress,
            customerPhone: invoice.customerPhone,
            customerBankName: invoice.customerBankName,
            customerBankCard: invoice.customerBankCard,
          });
        })
      }else{
        this.invoiceInfoList.forEach((invoice) => {
          console.log(invoice)
          if (!invoice.customerName || invoice.customerName === '') {
            invoice.showInvoiceTitleMsg = true;
            isOkNum++;
          }

          if (!invoice.amount || invoice.amount === 0) {
            invoice.showInvoiceAmountMsg = true;
            invoice.showInvoiceMsg = false;
            isOkNum++;
          }

          if (!this.receiveInfo || this.receiveInfo === '') {
            this.isShowReceiveInfoMsg = true;
            isOkNum++;
          }

          if (invoice.amount) {
            amountSum += parseFloat(invoice.amount);
          }

          invoiceList.push({
            businessType: invoice.businessType,
            customerName: invoice.customerName,
            amount: this.setAmount(invoice.amount),
            nsrsbh: invoice.nsrsbh,
            customerAddress: invoice.customerAddress,
            customerPhone: invoice.customerPhone,
            customerBankName: invoice.customerBankName,
            customerBankCard: invoice.customerBankCard,
          });
        });
      }

      console.log(amountSum , this.totalAmount)
      if (amountSum != this.totalAmount) {
        isOkNum++;
      }

      if (isOkNum > 0) return;

      let params = {
        ChannelCode:'1',
        Type:invoiceList.length>1 ? 2 : 1,
        Mobile:this.receiveType===2 ? this.receiveInfo : '',
        Email:this.receiveType===1 ? this.receiveInfo : '',
        InvoiceType:this.invoiceType,
        ReopenInvoiceApplyId:this.invoiceApplyId,
        InvoiceApplySplitReqDetail:invoiceList,
        BookingRecordIds:this.ApplyBookingRecordIds?.map(item => {
          return {
            encBookingRecordId: item.encBookingRecordId,
            amount:item.amount
          };
        }),
      }
      console.log('params',params)
      let {success,data, errMsg} = await api.booking.submitInvoice(params)
      if(success){
        await this.$router.push({
          path: '/Rccl.Booking/Booking/InvoiceDetailsProgress',
          query: {
            invoiceApplyId: data.invoiceApplyId,
          }
        })
      }else{
        this.$alert.show(errMsg);
      }
    },
    initAmount(i) {
      let amountArr = i.toString().split('.');
      let amountInteger = "0";
      let amountDecimal = ".00";
      if(i) {
        if(amountArr.length === 2) {
          amountInteger = amountArr[0];
          amountDecimal = '.'+amountArr[1];
        } else {
          amountInteger = amountArr[0];
        }
      }
      return {
        amountInteger,
        amountDecimal
      }
    },
    showInvoiceExplain(){
      this.isShowInvoiceExplain = true
    },
    changeAddInvoice(){
      this.isShowNsrsbn = false
      this.isShowAddInvoice = false
    }
  },
  watch: {
    'currentInvoice.businessType'(val) {
      if(val){
        this.isShowNsrsbn = false
        if(val===1){
          this.invoiceTypeInfo.title = '必填，个人姓名'
          this.invoiceTypeInfo.nsrsbh = '必填，身份证号'
          this.currentInvoice.nsrsbh = ''
          this.showBusinessList = false
        }else if(val===2){
          this.invoiceTypeInfo.title = '必填，公司名称'
          this.invoiceTypeInfo.nsrsbh = '必填，纳税人识别号'
        }else{
          this.invoiceTypeInfo.title = '必填，单位名称'
          this.invoiceTypeInfo.nsrsbh = '如有税号，请务必填写'
        }
      }
    }
  },
  computed: {

  }
}
</script>
<style lang="less" scoped>
.invoice-page{
  background-color: #f5f5f5;
  position: relative;
  padding-bottom: 27px;
  .invoice{
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 27px;
    background-color: #fff;
    .invoice-header{
      width: 1200px;
      height: 153px;
      display: flex;
      align-items: center;
      padding-left: 180px;
      box-sizing: border-box;
      background: linear-gradient(to left, #00aeea, #006ab6);
      .invoice-header-con{
        font-size: 20px;
        color: #fffefe;
        .invoice-header-title{
          line-height: 40px;
          display: flex;
          align-items: center;
          gap: 21px;
          .header-title-con{
            display: flex;
            align-items: baseline;
            .price-small{
              font-size: 17px;
            }
            .header-price{
              font-size: 29px;
              display: flex;
              align-items: baseline;
            }
          }
          .title-icon{
            width: 20px;
            height: 20px;
            display: block;
            cursor: pointer;
          }
        }
        .header-tips{
          font-size: 13px;
          margin-top: 5px;
          .header-tips-item{
            position: relative;
            padding-left: 17px;
            margin-bottom: 7.5px;
          }
          .header-tips-item::after{
            content: "";
            display: block;
            width: 6px;
            height: 6px;
            background: #fff;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(0,-50%);
          }
        }
      }
    }
    .invoice-con{
      margin: 0 auto;
      .invoice-info{
        width: 1155px;
        margin: 0 auto;
        border-bottom: 1px #f5f5f5 solid;
        .invoice-info-con{
          width: 840px;
          margin: 0 auto;
          .invoice-info-title{
            font-size: 17px;
            font-weight: bold;
            color: #333333;
            margin-top: 30px;
          }
          .invoice-type:last-child{
            border-bottom: none;
          }
          .invoice-type{
            width: 840px;
            display: flex;
            font-size: 16px;
            border-bottom: 1px #dde3e5 dashed;
            padding: 20px 0;
            margin: 0 auto;
            .invoice-type-left{
              color: #999999;
              width: 100px;
              text-align: left;
            }
            .invoice-type-right{
              color: #202020;
              cursor: pointer;
              .right-tips{
                padding-left: 27px;
                font-size: 13px;
                color: #999999;
              }
              .invoice-num{
                display: flex;
                align-items: center;
                gap: 29px;
                img{
                  display: block;
                  width: 20px;
                  height: 20px;
                  cursor: pointer;
                }
              }
              .title-select{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: calc(840px - 100px - 14px);
                position: relative;
                .title-select-img{
                  width: 9px;
                  height: 14px;
                }
              }
              .invoice-company{
                display: flex;
                align-items: center;
                cursor: pointer;
                width: calc(840px - 100px - 14px);
                justify-content: space-between;
                .invoice-company-title{
                  display: flex;
                  align-items: center;
                  gap: 14px;
                  .invoice-mark{
                    display: block;
                    height: 16px;
                  }
                }
              }
              .invoice-item-price{
                display: flex;
                align-items: center;
                gap: 20px;
                margin-top: 16px;
                position: relative;
                input{
                  width: 137px;
                  height: 31px;
                  border: 1px solid #dde3e5;
                  border-radius: 6px;
                  font-style: normal;
                  font-size: 14px;
                  padding-left: 19px;
                  margin-left: 5px;
                  color: #1c6ab6;
                }
              }
            }
          }
          .invoice-spilt{
            border-bottom: 1px #dde3e5 dashed;
          }
          .invoice-spilt:last-child{
            border-bottom: none;
          }
        }
      }
      .invoice-receive{
        width: 840px;
        margin: 0 auto;
        .invoice-receive-title{
          font-size: 17px;
          font-weight: bold;
          color: #333333;
          margin-top: 30px;
        }
        .invoice-receive-type{
          padding: 20px 0;
          display: flex;
          align-items: center;
          font-size: 16px;
          width: 100%;
          border-bottom: 1px #dde3e5 dashed;
          position: relative;
          cursor: pointer;
          .type-select-img{
            width: 21px;
            height: 21px;
          }
          .title-select{
            padding:  0 14px;
            width: 819px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            .info-tips{
              display: flex;
              align-items: center;
              gap: 30px;
            }
            .title-select-img{
              width: 9px;
              height: 14px;
            }
          }
        }
      }
      .relation-service{
        color: #006ab5;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 16px;
        width: 840px;
        margin: 30px auto 50px;
        cursor: pointer;
        text-decoration: #3f8fc7 underline;
        img{
          width: 23px;
          height: 23px;
        }
      }
      .submit-invoice{
        width: 370px;
        height: 50px;
        background: linear-gradient(to right, #fcbf00, #ffdb17);
        border-radius: 3px;
        font-size: 18px;
        line-height: 50px;
        text-align: center;
        color: #333333;
        margin: 0 auto;
        cursor: pointer;
      }
    }
    .noFilled{
      display: flex;
      align-items: center;
      font-size: 12px;
      gap: 5px;
      color: #fe0000;
      position: absolute;
      left: 140px;
      top: 50%;
      transform: translate(0,-50%);
      img{
        display: block;
        width: 14px;
        height: 14px  ;
      }
    }
  }
  .split-tips{
    width: 318px;
    height: 64px;
    background: rgba(32,32,32,0.58);
    border-radius: 6px;
    text-align: center;
    line-height: 64px;
    color: #fff;
    font-size: 18px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .addInvoice-con{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    .addInvoice-main{
      width: 802px;
      position: absolute;
      background: #fff;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      padding-bottom: 30px;
      .addInvoice-title{
        font-size: 17px;
        font-weight: bold;
        color: #333333;
        text-align: center;
        padding: 25px 0;
        border-bottom: 1px solid #d9d9d9;
        position: relative;
        .popup-close{
          width: 25px;
          height: 25px;
          position: absolute;
          padding: 5px;
          right: 14px;
          top: 14px;
          cursor: pointer;
        }
      }
      .addInvoice-form{
        padding: 15px 180px 0;
        position: relative;
        .addInvoice-item{
          display: flex;
          align-items: center;
          padding: 8px 0;
          position: relative;
          .addInvoice-item-title{
            width: 126px;
            font-size: 16px;
            color: #202020;
            text-align: left;
            position: relative;
            img{
              width: 17px;
              height: 17px;
              margin-left: 5px;
              cursor: pointer;
            }
          }
          .addInvoice-item-content{
            width: 351px;
            //justify-content: space-between;
            display: flex;
            align-items: center;
            position: relative;
            gap: 46px;
            .companySelect{
              position: absolute;
              top: 31px;
              left: 0;
              width: 100%;
              z-index: 9;
              box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
              border-radius: 6px;
              box-sizing: border-box;
              max-height: 300px;
              overflow-y: auto;
              font-size: 14px;
              background-color: #f5f5f5;
              padding: 8px 15px;
              //隐藏滚动条
              &::-webkit-scrollbar{
                display: none;
              }
              .companySelect-item{
                padding: 4px 0;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                border-bottom: 1px solid #dcdcdc;
                .companySelect-item-title{
                  color: #202020;
                }
                .companySelect-item-nsrsbh{
                  color: #999999;
                  font-size: 13px;
                }
              }
            }
            input[type="text"],input[type="number"]{
              width: 100%;
              height: 31px;
              border: 1px solid #bfbfbf;
              border-radius: 6px;
              font-style: normal;
              font-size: 13px;
              padding-left: 17px;
              color: #282828;
               &::-webkit-outer-spin-button,
               &::-webkit-inner-spin-button {
                  -webkit-appearance: none;
                  appearance: none;
                  margin: 0;
              }
              &::-webkit-input-placeholder{
                color: #bfbfbf;
              }
            }
          }
          .invoiceTypePopup{
            width: 549px;
            height: auto;
            position: absolute;
            top: 40px;
            background-color: rgba(32,32,32,0.7);
            color: #ffffff;
            font-size: 18px;
            border-radius: 20px;
            padding: 17px 30px;
            z-index: 9;
            .nsrsbh-con{
              .nsrsbh-type{
                font-size: 22px;
                font-weight: bold;
                margin-bottom: 20px;
              }
              .nsrsbh-con-item{
                position: relative;
                padding-left: 10px;
              }
            }
            .tips-dot{
              position: absolute;
              top: 13px;
              left: 0;
              transform: translate(-50%,-50%);
              display: block;
              width: 5px;
              height: 5px;
              background: #fff;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
        }
        .form-tips{
          font-size: 12px;
          color: #202020;
          width: 100%;
          margin-top: 8px;
          padding-left: 126px;
        }
        .receiveInfo-tips{
          height: 20px;
          .noFilled{
            display: flex;
            align-items: center;
            gap: 5px;
            color: #fe0000;
            justify-content: center;
            img{
              display: block;
              width: 14px;
              height: 14px  ;
            }
          }
        }
        .addInvoiceBtn{
          width: 370px;
          height: 50px;
          background: linear-gradient(to right, #fcbf00, #ffdb17);
          border-radius: 3px;
          font-size: 18px;
          font-weight: bold;
          line-height: 50px;
          text-align: center;
          color: #333333;
          margin: 14px auto 0;
          cursor: pointer;
        }
      }
      .invoice-explain{
        height: 400px;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0!important;
        img{
          width: 723px;
        }
      }
    //  设置滚动条颜色
      .invoice-explain::-webkit-scrollbar{
        width: 5px;
        height: 100%;
        background-color: #d9d9d9;
        border-radius: 50px;
        box-shadow: 0 0 0 1px #d9d9d9;
      }
      .invoice-explain::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 50px;
        width: 100%;
        background: #fcc300;
      }
    }
    .invoice-info-tips{
      width: 318px;
      height: 64px;
      background-color: rgba(32,32,32,0.7);
      color: #ffffff;
      font-size: 18px;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      border-radius: 6px;
      line-height: 64px;
    }
  }
  .receive-info{
    .addInvoice-form{
      padding: 15px 114px 0 !important;
    }
    .addInvoice-item-title{
      width: 160px !important;
    }
  }
}
.invoice-radio{
  margin-bottom: 0;
  font-weight: 400;
  display: flex;
  align-items: center;
  cursor: pointer;
  input{
    margin: 0 12px 0 0;
  }
}
/*单选框基本（未选中）的样式*/
.invoice-radio input[type="radio"]{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  display: block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-size: 100% auto;
  box-sizing:border-box;
  border:solid 1px #fcc300;
}
/*单选按钮选中后增加的样式*/
.invoice-radio input[type="radio"]:checked:before {
  content: "";
  display: block;
  width: 9px;
  height: 9px;
  margin: 2px;
  border-radius: 10px;
  background-color: #fcc300;
}
</style>